import { Chip, Divider, Grid2 as Grid, Paper, Typography } from "@mui/material";

import { Product } from "api/memberPortal/project/product/product.types";

import { ProficiencyFeedbackFormValues } from "../../../ProficiencyFeedbackForm.schema";

import MetricCard from "./UI/MetricCard";

interface ProficiencyFeedbackFormProps {
  feedbackForm: ProficiencyFeedbackFormValues | undefined;
  product: Product;
}
const EvaluationSummaryStats = ({
  product,
  feedbackForm,
}: ProficiencyFeedbackFormProps) => {
  const isVidResubmission = product.is_resubmission;
  return (
    <>
      <Grid container spacing={2}>
        <Grid size={4}>
          <MetricCard label={"ECRs Total"}>
            {feedbackForm?.ecrTotal ?? 0}
          </MetricCard>
        </Grid>

        <Grid size={4}>
          <MetricCard
            label={"ECRs submitted and/or resolved after check-in (PP2)"}
          >
            {feedbackForm?.ecrsAfterPp2 ?? 0}
          </MetricCard>
        </Grid>

        <Grid size={4}>
          <MetricCard label={"Check-out packages submitted"}>
            {feedbackForm?.checkOutPackageTotal ?? 0}
          </MetricCard>
        </Grid>
      </Grid>
      <Paper
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: 2,
        }}
      >
        <Typography variant="body1" color="secondary">
          VID Resubmission
        </Typography>
        <Chip
          label={isVidResubmission ? "Yes" : "No"}
          color={isVidResubmission ? "success" : "secondary"}
        />
      </Paper>
      <Divider sx={{ borderColor: "black", mt: 2 }} />{" "}
    </>
  );
};

export default EvaluationSummaryStats;
